export default __webpack_public_path__ + "static/media/lunarDesc.ab70d97f.png";